import React,{useState} from 'react'
import useStyle from './styles';
import {Card,CardMedia} from '@material-ui/core';
import { myCld } from '../../../cloudinaryImage';

const ImageView = ({images,s3Images}) => {
    const classes=useStyle();
    const[imageIndex,setImageIndex]=useState(0);
    const[selected,setselected]=useState(0)
   const onThumbNailCLick=(index)=>{
     setselected(index)
     setImageIndex(index)
     
   }

  const FilledImages =({s3Images})=>(
     <div className={classes.viewcontainer}>
     <div className={classes.thumbnailContainer}>
          {process.env.REACT_APP_WEB_IMAGE_LOCATION ==='s3' && s3Images.length ? <div className={classes.thumbnailList}>
            {
              s3Images.map((img,index) =>(
                <Card className={classes.root} key={index}>

                <CardMedia className={`${classes.mediaThumbnail} ${selected===index? classes.select:  classes.disSelect} `} onClick={()=>{onThumbNailCLick(index)}}  image={img.url}/* {`${img.secure_url}`} */ title={img.resource_type}/>

                 </Card>
              ))
            }
           </div> : <div className={classes.thumbnailList}>
            {
              images.map((img,index)=>(
                <Card className={classes.root} key={index}>
               
               
                  <CardMedia className={`${classes.mediaThumbnail} ${selected === index ? classes.select : classes.disSelect} `} onClick={()=>{onThumbNailCLick(index)}}  image={myCld.image(`${img.public_id}`).format('auto').quality('auto').addFlag('lossy').toURL()}/* {`${img.secure_url}`} */ title={img.resource_type}/>
                
                

                </Card>
              ))
            }
           </div>
}
     </div>

     <div className={classes.previewContainer}>
           <Card>
            {
             process.env.REACT_APP_WEB_IMAGE_LOCATION ==='s3' && s3Images.length ? 
             <CardMedia className={classes.mediaPreview} id="img-preview"  image={s3Images[imageIndex].url}/* {images[imageIndex].secure_url} */ title={images[imageIndex].resource_type}/> :
             
             <CardMedia className={classes.mediaPreview} id="img-preview"  image={myCld.image(`${images[imageIndex].public_id}`).format('auto').quality('auto').addFlag('lossy').toURL()}/* {images[imageIndex].secure_url} */ title={images[imageIndex].resource_type}/>
            }
           
            </Card>
     </div>
     
   </div>
  )


 
  return (
    <div className={classes.container}>{
       images.length > 0 || s3Images.length > 0 ?  <FilledImages s3Images={s3Images}/>:'loading ...'
      }
   </div>
  )
}

export default ImageView
